// extracted by mini-css-extract-plugin
export default {"container":"AdminPanel_container__O7Jpq","title":"AdminPanel_title__zkJcW","table":"AdminPanel_table__aGZAi","tableCell":"AdminPanel_tableCell__YvyjU"};